import { render, staticRenderFns } from "./PublicTransitCard.vue?vue&type=template&id=54b1bf4c&scoped=true&"
import script from "./PublicTransitCard.vue?vue&type=script&lang=js&"
export * from "./PublicTransitCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicTransitCard.vue?vue&type=style&index=0&id=54b1bf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1bf4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b1bf4c')) {
      api.createRecord('54b1bf4c', component.options)
    } else {
      api.reload('54b1bf4c', component.options)
    }
    module.hot.accept("./PublicTransitCard.vue?vue&type=template&id=54b1bf4c&scoped=true&", function () {
      api.rerender('54b1bf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicTransitCard.vue"
export default component.exports